<section [class.section-title]="!!data().title" [style.background-color]="style().backgroundColor | color: 'CREAM'">
  <div class="container">
    @if (title()) {
      <div class="row center-lg">
        <div class="col-xs-12 col-lg-8">
          <app-title [titles]="[title()]" class="title-section" />
        </div>
      </div>
    }
    <div class="row">
      <div class="col-xs-12 col-lg-5">
        @for (item of items(); track item) {
          <div #blockElements class="block">
            @if (item.titles; as titles) {
              <app-title [titles]="titles" />
            }
            @if (item.text; as text) {
              <p [innerHTML]="text" [style.color]="style().textColor | color: 'BLACK'"></p>
            }
            @if (item.cta && item.cta.url && item.cta.label) {
              <app-button
                [icon]="{ name: 'CHEVRON_RIGHT' }"
                [label]="item.cta.label"
                [theme]="'FULL_WHITE'"
                [url]="item.cta.url"
                class="button" />
            }
            @if (breakpoints() === "mobile" && item.image; as image) {}
          </div>
        }
      </div>
      @if (breakpoints() === "desktop") {
        <aside class="col-lg-6 col-lg-offset-1 sticky">
          @if (data().items[activatedImg()]!.image; as image) {
            <app-image [image]="image" [size]="{ mh: 367, dw: 600, dh: 660 }" />
          }
        </aside>
      }
    </div>
  </div>
</section>
